module.exports = __webpack_public_path__ + "img/grupoAllColor.a464fc61.png";